import cn from "clsx";
import styles from "../_components/base-table/BaseTable.module.scss";

export function getGroupingClassNames(
    travelerIndex: number,
    groupSize: number,
) {
    const isSameBookingAsPrevious = travelerIndex > 0;
    const isSameBookingAsNext = travelerIndex < groupSize - 1;
    const classNames = cn({
        [styles["row--no-border-top"]]: isSameBookingAsPrevious,
        [styles["row--no-border-bottom"]]: isSameBookingAsNext,
    });
    return classNames;
}
